import React from "react";

const BenefitsSidebar = ({ title, benefits }) => {
  return (
    <div className="relative flex flex-col items-start justify-center min-h-screen p-8 lg:p-12 xl:p-16 text-white overflow-hidden bg-gradient-to-br from-slate-900 via-slate-800 to-slate-900">
      {/* Animated gradient orbs */}
      <div className="absolute inset-0 overflow-hidden">
        <div className="absolute -top-20 -left-20 w-72 h-72 bg-gradient-to-br from-orange-500/30 to-amber-500/20 rounded-full blur-3xl animate-pulse" />
        <div className="absolute bottom-1/4 -right-20 w-60 h-60 bg-gradient-to-br from-blue-600/20 to-cyan-500/10 rounded-full blur-3xl animate-pulse [animation-delay:1s]" />
        <div className="absolute -bottom-10 left-1/4 w-48 h-48 bg-gradient-to-br from-orange-600/20 to-rose-500/10 rounded-full blur-3xl animate-pulse [animation-delay:2s]" />
      </div>

      {/* Grid pattern overlay */}
      <div className="absolute inset-0 bg-[linear-gradient(rgba(255,255,255,0.02)_1px,transparent_1px),linear-gradient(90deg,rgba(255,255,255,0.02)_1px,transparent_1px)] bg-[size:48px_48px]" />

      {/* Content */}
      <div className="relative z-10 space-y-8 lg:space-y-10">
        {/* Logo/Brand mark */}
        <div className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-white/5 border border-white/10 backdrop-blur-sm">
          <span className="relative flex h-2 w-2">
            <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-orange-400 opacity-75"></span>
            <span className="relative inline-flex rounded-full h-2 w-2 bg-orange-500"></span>
          </span>
          <span className="text-sm font-medium text-orange-300">Prep5 by Salesably</span>
        </div>

        {/* Main heading */}
        <h1 className="text-3xl lg:text-4xl xl:text-5xl font-bold leading-tight tracking-tight">
          {title}
          <span className="block mt-3 text-transparent bg-clip-text bg-gradient-to-r from-orange-400 via-amber-400 to-orange-500">
            In 5 Minutes or Less
          </span>
        </h1>

        {/* Benefits list */}
        <ul className="space-y-4 lg:space-y-5">
          {benefits.map((benefit, index) => (
            <li
              className="flex items-start gap-3 text-base lg:text-lg text-slate-200"
              key={index}
              style={{ animationDelay: `${index * 100}ms` }}
            >
              <div className="flex-shrink-0 mt-1 p-1 rounded-full bg-gradient-to-br from-green-500/20 to-emerald-500/20 border border-green-500/30">
                <svg
                  className="w-4 h-4 text-green-400"
                  fill="none"
                  stroke="currentColor"
                  viewBox="0 0 24 24"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={2.5}
                    d="M5 13l4 4L19 7"
                  />
                </svg>
              </div>
              <span className="leading-relaxed">{benefit}</span>
            </li>
          ))}
        </ul>

      </div>
    </div>
  );
};

export default BenefitsSidebar; 